import React from "react";

const Experience = () => {
  return (
    <div>
      <div className="col-md-12 mt-5">
        <h1 className="mb-4 my-skill purple ">
          <strong>Experience</strong>
        </h1>
        <div className="education w-100 m-auto text-center">
          <h4 className="">Junior Software Developer</h4>
          <h5>
            <span className="purple "> Softeko.</span>{" "}
            <small> Dhaka, Bangladesh</small>
          </h5>

          <p>August 2023 - Present</p>
        </div>
        <br />
        <div className="education w-100 m-auto text-center">
          <h4 className="">Software Engineer (A1)</h4>
          <h5>
            <span className="purple ">
              {" "}
              Profecia Links Consulting Pvt. Ltd.
            </span>{" "}
            <small> Pune, India</small>
          </h5>

          <p>March 2022 - July 2023</p>
        </div>
        <br />
      </div>
    </div>
  );
};

export default Experience;
